import { Img } from "react-image";
import { Suspense } from "react";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/certificates")({
  component: PageCertificates,
});

export default function PageCertificates() {
  useDocumentTitle("证照中心 - 兽聚汇");

  return (
    <div className={"flex min-h-screen flex-col items-center bg-gray-100"}>
      <Suspense fallback={<div>加载中....</div>}>
        <div className={"m-8 flex flex-col gap-8"}>
          <div className={"text-center"}>
            <h1 className={"mb-4 text-xl"}>营业执照</h1>
            <Img
              src={"https://oss.furries.cn/static/certificates/business_license.jpg!certificates"}
              alt={"营业执照"}
            />
          </div>
          <div className={"text-center"}>
            <h1 className={"mb-4 text-xl"}>版权证书</h1>
            <Img
              src={"https://oss.furries.cn/static/certificates/copyright-license.jpg!certificates"}
              alt={"计算机软件著作权登记证书"}
            />
          </div>
          <div className={"text-center"}>
            <h1 className={"mb-4 text-xl"}>电信许可</h1>
            <Img
              src={"https://oss.furries.cn/static/certificates/e-commerce_license.jpg!certificates"}
              alt={"电信业务经营许可证"}
            />
          </div>
          <div className={"text-center"}>
            <h1 className={"mb-4 text-xl"}>拍卖许可</h1>
            <Img
              src={"https://oss.furries.cn/static/certificates/auction_license.png!certificates"}
              alt={"拍卖许可证"}
            />
          </div>
        </div>
      </Suspense>
    </div>
  );
}
